import { Box } from "@mui/material";

export const HeaderUnderLine = (props: {
  marginLeft?: string;
  width?: string;
}) => {
  return (
    <Box
      style={{
        width: props.width ? props.width : "98%",
        marginTop: "7px",
        backgroundColor: "#E2E2E2",
        borderTop: "3px solid #E2E2E2",
        height: "3px",
        marginLeft: props.marginLeft ? props.marginLeft : ""
      }}
    ></Box>
  );
};
